import { useMutation } from '@tanstack/react-query';
import { api } from '@/services/api';

export interface AiAssistantResponse {
  answer: string;
  data_table?: {
    headers: string[];
    rows: string[][];
  };
  references?: Array<{
    type: string;
    id: string;
    label: string;
  }>;
  sources_queried: string[];
}

export function useAiQuery() {
  return useMutation({
    mutationFn: async ({ query, incidentId }: { query: string; incidentId?: string }) => {
      const response = await api.post<{ data: AiAssistantResponse }>('/ai-assistant/query', {
        query,
        incidentId,
      });
      return response.data;
    },
  });
}
